<template>
	<modal :modalOpen="modalOpen" :modalId="'preLoginModal'" @close="$emit('close')">
		<div class="banner-content" slot="banner">
			<md-button class="close-btn md-icon-button md-dense" @click="$emit('close')">
				<base-icon icon-name="close" />
			</md-button>
			<!-- person -->
			<PersonIcon class="banner-icons"></PersonIcon>
			<div class="banner-arrows">
				<!-- top arrow -->
				<TopArrowIcon class="banner-icons"></TopArrowIcon>
				<!-- bottom arrow -->
				<BottomArrowIcon class="banner-icons"></BottomArrowIcon>
			</div>
			<!-- computer -->
			<ComputerIcon class="banner-icons"></ComputerIcon>
		</div>
		<h5 class="mobile-H5-5" slot="header">{{ preLoginData.headline }}</h5>
		<div class="content preloginBody">
			<p class="body-1">{{ preLoginData.title }}</p>
			<ul>
				<li v-for="(listItem, index) in preLoginData.list" :key="index">
					<base-icon class="prelogin_icon" icon-name="check-round" />
					<span class="body-1"> {{ listItem }} </span>
				</li>
			</ul>
		</div>
		<template slot="footer">
			<md-button class="md-primary md-button-large md-raised login-button button" @click="saveAfterLogin">
				Log in to My QIAGEN
			</md-button>
			<a class="body-1" :href="registerLink" @click="trackingRegister">Don't have an account? Register now</a>
		</template>
	</modal>
</template>

<script>
import PersonIcon from '@/assets/icons/person.svg';
import TopArrowIcon from '@/assets/icons/top-arrow.svg';
import BottomArrowIcon from '@/assets/icons/bottom-arrow.svg';
import ComputerIcon from '@/assets/icons/computer.svg';

import {trackEvent} from '@/services/tracking.js';

export default {
	name: 'PreLoginModal',
	components: {
		PersonIcon: PersonIcon,
		TopArrowIcon: TopArrowIcon,
		BottomArrowIcon: BottomArrowIcon,
		ComputerIcon: ComputerIcon,
	},
	props: {
		modalOpen: {
			type: Boolean,
		},
		preLoginData: {
			type: Object,
		},
		registerLink: {
			type: String,
		},
	},
	methods: {
		trackingRegister() {
			trackEvent('ctaClick', {eVar58: 'Register | Workflow Configurator'});
		},
		saveAfterLogin() {
			if (localStorage.getItem('shareOnReturn') || localStorage.getItem('setLabNotesActiveOnReturn')) {
				this.$emit('sendToLogin', false);
			} else {
				this.$emit('sendToLogin');
			}
			this.$emit('close');
		},
	},
};
</script>

<style lang="scss" scoped>
.content {
	p,
	ul li {
		margin-bottom: 8px;
		&:last-child {
			margin-bottom: 0;
		}
	}
	ul {
		list-style-type: none;
		padding: 0;
		margin: 0;
		margin-left: -3px;
		max-width: calc(500px - 48px);
		li {
			@include flexRow;
			align-items: flex-start;
			svg {
				min-width: 18px;
				margin-top: 2px;
			}
		}
	}
}
.banner-content {
	height: 100%;
	width: 100%;
	@include flexRow;
	align-items: center;
	justify-content: space-evenly;
	position: relative;

	@media (max-width: $mobile) {
		justify-content: space-evenly;
	}

	button.md-theme-default.close-btn {
		position: absolute;
		top: 0;
		right: 0;
		&.md-icon-button.md-dense {
			width: 30px;
			min-width: 30px;
			height: 30px;
			margin-top: 12px;
			margin-right: 14px;

			@media (max-width: $mobile) {
				margin-top: 0px;
				margin-right: 0px;
				top: -10px;
				right: -10px;
			}
		}
		img {
			margin: 0;
		}
	}
	img.banner-icons {
		@media (max-width: $mobile) {
			height: 56px;
		}

		&:nth-of-type(1) {
			margin-left: 10px;

			@media (max-width: $mobile) {
				margin-left: 0px;
			}
		}
		&:last-child {
			margin-right: 36px;

			@media (max-width: $mobile) {
				margin-right: 0px;
			}
		}
	}
	.banner-arrows {
		@media (max-width: $mobile) {
			width: 28px;
		}

		@include flexColumn;
		img {
			margin: 0;
			&:nth-of-type(1) {
				margin-bottom: 12px;
			}
		}
	}
}
.prelogin_icon {
	color: $color-blue;
	margin-right: 8px;
}
.md-theme-default button.md-button.login-button {
	margin-bottom: 16px;
	padding: 0 5px; //remove once button styling is fixed
	.md-ripple {
		padding: 0 !important;
	}

	@media (max-width: $mobile) {
		width: 100%;
	}
}
</style>
